import { auth } from "./modules/firebase";

let fallingInterval;
let score = 0;
let elementAmount = 0;

const otherImages = {
    0: {img:"./images/penguins/Penguin.png", score: 1},
    1: {img:"/images/fish/salmon.png", score: 2},
    2: {img:"/images/fish/krill.png", score: 3},
    3: {img:"/images/fish/squid.png", score: 4},
    5: {img:"/images/fish/goldFish.png", score: 5},
    6: {img:"/images/elements/blueBerry.png", score: 10},
};

function addFallingImage() {
    const pageContent = document.getElementById('pageContent');
    if (!pageContent) {
        destroy_falling_penguins()
        return
    };

    if(elementAmount < 20){
        const wrapper = document.createElement('div');
        wrapper.className = 'falling-wrapper';
        wrapper.style.left = Math.random() * (window.innerWidth - 150) + 'px'; // Adjusted wrapper width for better placement
    
        const img = document.createElement('img');
        const randInt = getRandomInt(0, 5);
        
        let index = 0
        if(randInt === 0){
            index = Object.keys(otherImages).length - 1
        }
       
        img.src = otherImages[index].img;
    
        img.className = 'falling-image';
        img.draggable = false;
    
        // Center the image inside the wrapper
        wrapper.appendChild(img);
        elementAmount += 1
    
        // Add click event to the wrapper instead of the image
        wrapper.addEventListener("pointerdown", () => {
            img.classList.add("clicked");
            setTimeout(() => {
                wrapper.remove()
                score += otherImages[index].score;
                document.getElementById("score").innerHTML = "SCORE: " + score;
                elementAmount -= 1
            }, 100); // Remove the wrapper after animation ends
        });
    
        pageContent.appendChild(wrapper);
    
        // Remove automatically after 10 seconds
        setTimeout(() => {
            wrapper.remove();
            elementAmount -= 1
        }, 10000);
    }
}

fallingInterval = setInterval(addFallingImage, 1000);

export function destroy_falling_penguins() {
    clearInterval(fallingInterval);
}

function getRandomInt(min, max) {
    const minCeiled = Math.ceil(min);
    const maxFloored = Math.floor(max);
    return Math.floor(Math.random() * (maxFloored - minCeiled + 1) + minCeiled)
}

document.getElementById('playGame').addEventListener('click',()=>{
    window.location = '/game'
})

auth.onAuthStateChanged(user => {
    if (user) {
        window.location = '/game';
    }
});

let darkMode = false;

async function initDarkMode(){
    darkMode = JSON.parse(localStorage.getItem("darkMode"))
    if(darkMode == null){
        // Check to see if Media-Queries are supported
        if (window.matchMedia) {
            // Check if the dark-mode Media-Query matches
            if(window.matchMedia('(prefers-color-scheme: dark)').matches){
                darkMode = true
            } else {
                darkMode = false
            }
        }
    }

    setDayNight()
}

initDarkMode()

function setDayNight(){
    if(darkMode){
        document.body.style.backgroundColor = "#EEEEEE"
        document.body.style.color = "#000000"
    }else{
        document.body.style.backgroundColor = "rgb(53, 53, 53)"
        document.body.style.color = "rgb(255, 187, 0)"
    }
}